var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32 152C36.4182 152 40 155.582 40 160C40 175.311 40.017 185.989 41.1003 194.047C42.1525 201.874 44.0773 206.018 47.0294 208.971C49.9815 211.923 54.1264 213.847 61.9533 214.9C70.0103 215.983 80.689 216 96 216H160C175.311 216 185.989 215.983 194.047 214.9C201.874 213.847 206.018 211.923 208.971 208.971C211.923 206.018 213.847 201.874 214.9 194.047C215.983 185.989 216 175.311 216 160C216 155.582 219.582 152 224 152C228.418 152 232 155.582 232 160V160.586C232 175.173 232 186.931 230.757 196.179C229.467 205.78 226.705 213.863 220.285 220.284C213.863 226.705 205.78 229.467 196.179 230.757C186.931 232 175.173 232 160.586 232H95.4147C80.8271 232 69.069 232 59.8213 230.757C50.2202 229.467 42.1362 226.705 35.7157 220.285C29.2953 213.863 26.5338 205.78 25.2429 196.179C23.9996 186.931 23.9998 175.173 24 160.586C24 160.39 24 160.195 24 160C24 155.582 27.5818 152 32 152Z",
    fill: "#3C4149",
    stroke: "#3C4149",
    strokeWidth: 10.6667
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128 178.667C130.246 178.667 132.388 177.723 133.904 176.065L176.571 129.398C179.552 126.138 179.326 121.077 176.065 118.096C172.804 115.115 167.744 115.341 164.763 118.602L136 150.061V32C136 27.5818 132.418 24 128 24C123.582 24 120 27.5818 120 32V150.061L91.2376 118.602C88.2563 115.341 83.196 115.115 79.9352 118.096C76.6744 121.077 76.4478 126.138 79.4291 129.398L122.096 176.065C123.612 177.723 125.754 178.667 128 178.667Z",
    fill: "#3C4149",
    stroke: "#3C4149",
    strokeWidth: 10.6667
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.3a6c37f4b363650775c14a3368a17103.svg";
export { ForwardRef as ReactComponent };